import _ from 'underscore';

import { mapBPTime } from './business-hours-mapping';

export const businessDays = {
  mon: _TL_('Monday'),
  tue: _TL_('Tuesday'),
  wed: _TL_('Wednesday'),
  thu: _TL_('Thursday'),
  fri: _TL_('Friday'),
  sat: _TL_('Saturday'),
  sun: _TL_('Sunday'),
  holiday: _TL_('Holidays'),
};

export const paddingZero = number => (
  number > 9 ? number.toString() : `0${number}`
);

// 0:10 => 12:10 AM
// 12:10 => 12:10 PM
export const timeToString = (time, format = 'h:mm') => {
  if (!time || time.hour === null || time.minute === null ||
    time.hour === undefined || time.minute === undefined) {
    return '';
  }

  const { hour, minute = 0, second = 0 } = time;
  const h12 = hour > 12 ? hour - 12 : hour;
  const formatHour = hour === 0 ? 12 : hour;

  switch (format) {
    case 'h':
      return hour >= 12 ? `${h12} PM` : `${formatHour} AM`;
    case 'h:mm':
      return hour >= 12 ?
        `${h12}:${paddingZero(minute)} PM` :
        `${formatHour}:${paddingZero(minute)} AM`;
    case 'hh':
      return hour >= 12 ? `${paddingZero(h12)} PM` : `${paddingZero(formatHour)} AM`;
    case 'hh:mm':
      return hour >= 12 ?
        `${paddingZero(h12)}:${paddingZero(minute)} PM` :
        `${paddingZero(formatHour)}:${paddingZero(minute)} AM`;
    case 'HH':
      return `${paddingZero(hour)}`;
    case 'hh:mm:ss':
      return hour >= 12 ?
        `${paddingZero(h12)}:${paddingZero(minute)}:${paddingZero(second)} PM` :
        `${paddingZero(formatHour)}:${paddingZero(minute)}:${paddingZero(second)} AM`;
    case 'HH:mm':
    default:
      return `${paddingZero(hour)}:${paddingZero(minute)}`;
  }
};

export const getIsOpenAllDay = (day = {}) => {
  const { isOpenAllDay, timeSlots } = day;

  if (isOpenAllDay) {
    return true;
  }
  // For those not including isOpenAllDay field, judge on timeslots.
  // 12:00 AM - 11:59 PM will be regarded as all day.
  if (
    timeSlots.length === 1 && timeSlots[0]
    && timeSlots[0].openHour === 0 && timeSlots[0].openMinute === 0
    && timeSlots[0].closeHour === 23 && timeSlots[0].closeMinute === 59
  ) {
    return true;
  }

  return false;
};

/**
 * Change UI hours to WSD desired format.
 * @param {Array} hours Hours stored in UI side.
 * @returns {Array} Hours format in WSD
 */
export const mapHoursToWSDFormat = (hours = []) => _.map(hours, (item) => {
  const { day, timeSlots } = item;

  const formattedDay = businessDays[day];
  const formattedHours = _.map(timeSlots, (slot) => {
    const startTime = timeToString({ hour: slot.openHour, minute: slot.openMinute }, 'hh:mm:ss');
    const endTime = timeToString({ hour: slot.closeHour, minute: slot.closeMinute }, 'hh:mm:ss');
    return {
      StartTime: startTime,
      EndTime: endTime,
    };
  });

  return {
    Day: formattedDay,
    IsClosed: _.isEmpty(timeSlots),
    IsOpenAllDay: getIsOpenAllDay(item),
    OperationHours: formattedHours,
  };
});

/**
 * Change hours stored in WSD to UI format
 * @param {Array} hours Hours stored in WebsiteSourceData
 * @returns {Array} Hours in UI desired format.
 */
export const mapWSDHoursToHours = (hours = []) => _.map(
  hours,
  (item) => {
    const {
      Day,
      IsClosed,
      OperationHours,
      IsOpenAllDay,
    } = item;
    let formattedDay = Day;
    if (typeof Day === 'string' && Day !== 'Holidays') {
      formattedDay = Day.slice(0, 3).toLowerCase();
    } else {
      formattedDay = 'holiday';
    }

    const formattedTimeSlots = IsClosed ? [] : mapBPTime(OperationHours);
    return {
      day: formattedDay,
      isValid: true,
      isOpenAllDay: IsOpenAllDay,
      timeSlots: formattedTimeSlots,
    };
  }
);
